module.exports = __webpack_public_path__ + "static/media/chan_chia_hsu.ea96acbe.jpg";